import { render, staticRenderFns } from "./TableWidget.vue?vue&type=template&id=5c3c3436&"
import script from "./TableWidget.vue?vue&type=script&lang=js&"
export * from "./TableWidget.vue?vue&type=script&lang=js&"
import style0 from "./TableWidget.vue?vue&type=style&index=0&id=5c3c3436&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports